import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { workflowConfigs } from '../core/workflowConfigs';
import { handleWorkflowTrigger } from '../core/workflowTrigger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useChatPanelStore from 'stateManagement/store/useChatPanelStore';

import { useGetSessionById } from 'stateManagement/queries/services/aiChat/aiChatQueries';

import { createActionPlan } from 'stateManagement/redux/actionPlans/slice';

const WorkflowDropdown = ({ authReducer: { user }, isDisabled }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const chatSessionId = useChatPanelStore((state) => state.chatSessionId);
  const { data: chatData } = useGetSessionById(chatSessionId);

  const scrollToBottom = (smooth = true) => {
    setTimeout(() => {
      const parentDiv = document.querySelector('#scrollable-panel-content');
      if (parentDiv) {
        parentDiv.style.overflow = 'auto';
        parentDiv.scrollTo({
          top: parentDiv.scrollHeight,
          behavior: smooth ? 'smooth' : 'auto',
        });
      }
    }, 100);
  };

  const onWorkflowClick = (workflowType) => {
    const plan = handleWorkflowTrigger(
      workflowType,
      location.pathname,
      state,
      chatSessionId,
      location.search
    );
    if (plan) {
      dispatch(createActionPlan(plan));
      scrollToBottom();
    }
  };

  // Filter workflows based on current path
  const workflowOptions = workflowConfigs.filter(
    (workflow) =>
      location.pathname.includes(workflow.path) &&
      location.pathname !== workflow.path &&
      location.pathname !== `${workflow.path}/`
  );

  // Only hide if not the creator of the chat session and there are no workflow options
  if (chatData.createdBy._id !== user._id || workflowOptions.length === 0) {
    return null;
  }

  return (
    <Dropdown drop='up'>
      <style>{`
        .no-arrow::after {
          display: none !important;
        }
      `}</style>

      <Dropdown.Toggle
        variant='falcon-primary'
        id='chat-sessions-dropdown'
        size='sm'
        className='no-arrow'
        disabled={isDisabled}
      >
        <FontAwesomeIcon icon='list-check' />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Header>Workflows</Dropdown.Header>

        {workflowOptions.map((workflow) => (
          <Dropdown.Item
            key={workflow.id}
            onClick={() => onWorkflowClick(workflow.workflowType)}
          >
            <div className='d-flex align-items-center justify-content-between gap-2'>
              {workflow.buttonText}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
});

export default connect(mapStateToProps, {})(WorkflowDropdown);
